import { Group, MantineTheme } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { ReactNode } from "react";


export function ClientesTiendasServiciosOverrides(theme: MantineTheme) {
    return {
        2: { render: (value: unknown) => (!value || value === '0') ? <Group><IconAlertTriangleFilled style={{ color: theme.colors.yellow[8] }} size="1.3rem" />Sin productos</Group> : value as ReactNode },
    }

}
